export default "__VITE_ASSET__bd0b20a3__"